import { render, staticRenderFns } from "./NoImageIcon.vue?vue&type=template&id=7de7acdd&scoped=true&lang=pug"
var script = {}
import style0 from "./NoImageIcon.vue?vue&type=style&index=0&id=7de7acdd&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de7acdd",
  null
  
)

export default component.exports